import { render, staticRenderFns } from "./PromotionCreditCardReview.vue?vue&type=template&id=5e612102&"
import script from "./PromotionCreditCardReview.vue?vue&type=script&lang=js&"
export * from "./PromotionCreditCardReview.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCreditCardReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionCreditCardReview.vue"
export default component.exports